import React from "react";

const FeatureCard = ({ title, body }) => (
  <li className="provider-beta__benefit-item">
    <h3 className="provider-beta__benefit-heading">{title}</h3>
    <p className="provider-beta__benefit-desc">{body}</p>
  </li>
);

export default FeatureCard;
